module.exports = __webpack_public_path__ + "ClientApp/content/VetResourceCenter/Sedation-protocols-lap-of-love.jpg";